import { render, staticRenderFns } from "./AnnounceKitContainer.vue?vue&type=template&id=39f49852"
import script from "./AnnounceKitContainer.vue?vue&type=script&lang=js"
export * from "./AnnounceKitContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports